<template>
  <p-container>
    <p-row>
      <p-col xs12>
        <p-row column dense>
          <h3>
            {{ $t("core.page.resetPassword.page.title") }}
          </h3>
          <p class="caption-1">
            {{ $t("core.page.resetPassword.page.description") }}
          </p>
        </p-row>
      </p-col>
      <p-col xs12>
        <p-form :model="reset" no-summary>
          <p-text-field v-model="reset.eMail" type="email" autocomplete="email" :label="$t('core.page.resetPassword.label.email')" @keyup.enter="doResetPassword()"></p-text-field>
        </p-form>
      </p-col>

      <p-col xs12>
        <p-row>
          <p-button
            :loading="isLoading"
            :disabled="isLoading"
            @click="doResetPassword()"
          >
            {{ $t("core.page.resetPassword.button.resetPassword") }}
          </p-button>
          <p-button
            secondary
            :loading="isLoading"
            :disabled="isLoading"
            @click="gotoLogin()"
          >
            {{ $t("core.app.back") }}
          </p-button>
        </p-row>
      </p-col>
      <p-col xs12>
        <p-request-alert v-model="requestError"></p-request-alert>
        <p-alert v-model="success" type="success">
          {{ $t('core.page.resetPassword.label.passwordReset') }}
        </p-alert>
      </p-col>
    </p-row>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';
  import UserForgotPasswordRequestViewModel from '../../../services/v1/viewModel/resource/UserForgotPasswordRequestViewModel';

  export default Vue.extend({
    auth: false,
    layout: ['layout-exterior', '_exterior'],
    data: () => ({
      reset: new UserForgotPasswordRequestViewModel(),
      isLoading: false,
      requestError: undefined,
      success: false,
      email: '',
      url: '',
    }),
    methods:
      {
        async doResetPassword() {
          if (!this.reset.validate()) {
            return;
          }
          this.isLoading = true;
          try {
            await this.$service.api.core.users.forgotPassword(this.reset);
            this.success = true;
          } catch (e: any) {
            this.requestError = e;
          }
          this.isLoading = false;
        },
        gotoLogin() {
          Vue.$router.push({ path: '/_exterior/login', query: this.$route.query });
        },
      },
  });
</script>
